import I18n from 'i18n-js';

export const ticketPageTitle = (ticketId = null) => (
  ticketId
    ? I18n.t('tickets.page_title_with_id', { id: ticketId })
    : I18n.t('tickets.page_title')
);
